'use client'

import { Suspense } from 'react'
import { useSearchParams } from 'next/navigation'
import { ClientDashboardPreview } from '@/features/investor'
import { Skeleton } from '@/components/ui/skeleton'
import { AdminShell } from '@/features/admin/components/admin-shell'
import type { FlowType } from '@/features/cases'

/** Reads `?flow=` itself instead of the page taking it via `searchParams` — see
 * `staff-client-detail-view.tsx` for why (a simplification; does NOT fix the tab-title flicker). */
function AdminClientDashboardPreviewContent({ investorId }: { investorId: string }) {
  const flow = useSearchParams().get('flow')
  const defaultFlow: FlowType = flow === 'trades' ? 'trades' : flow === 'build' ? 'build' : 'audit'
  return <ClientDashboardPreview investorId={investorId} defaultFlow={defaultFlow} mode="admin" />
}

export function AdminClientDashboardPreviewView({ investorId }: { investorId: string }) {
  return (
    <AdminShell active="cases">
      <Suspense fallback={<Skeleton className="h-64 w-full" />}>
        <AdminClientDashboardPreviewContent investorId={investorId} />
      </Suspense>
    </AdminShell>
  )
}
